<div class="loader" *ngIf="loading">
    <div style="text-align: center;">
        <div style="font-size: 17px;">
            <span>{{loading}}</span>
        </div>
        <span class="loader-spiner"></span>
    </div>
</div>